<p-tabView class="mt-4 ar-payment">
  <button *ngIf="isCustomerPaymentEnabled" class="btn btn-primary roa-action-btn"
    (click)="openCustomerPaymentsDialog()">
    ROA
  </button>

  <p-tabPanel header="Summary">
    <div class="ar-account">
      <div class="content" [ngClass]="{'div-disabled': loading}">
        <div class="p-0 ui-g-12">
          <div class="mb-1 ui-g-5 p-0 font-700 font-18">
            Account Details
          </div>
        </div>

        <div class="ui-g-12 p-0 ar-account-card flex-between-center">
          <div class="ui-g-4 pl-0">
            <div class="ar-account-box">
              <div class="ar-account-content">
                <div class="ar-account-left-box">
                  <h6 class="account-header">
                    <span>Limit Allowed</span>
                    <i class="fal fa-info-circle font-12 ml-2" tooltipPosition="top"
                      pTooltip="Maximum credit limit allowed for the customer's accounts receivable. This is the highest amount the customer can owe."></i>
                  </h6>
                  <span *ngIf="customer?.chargeAccountDetails?.unlimited">Unlimited</span>
                  <span [hidden]="customer?.chargeAccountDetails?.unlimited" class="ar-account-number">
                    {{customer?.chargeAccountDetails?.allowedLimit | currency: 'USD' }}
                  </span>
                </div>
                <div class="ar-account-right-box" *ngIf="isArAccountPermitted">
                  <i class="far fa-edit fa-fw font-18 pointer"
                    (click)="updateArLimit(customer?.chargeAccountDetails?.allowedLimit)"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-4">
            <div class="ar-account-box">
              <div class="ar-account-content">
                <div class="ar-account-left-box">
                  <h6 class="account-header">
                    Limit Used
                    <i class="fal fa-info-circle font-12 ml-2" tooltipPosition="top"
                      pTooltip="Current amount of credit used by the customer, representing their outstanding accounts receivable balance."></i>
                  </h6>
                  <span class="ar-account-number">
                    {{(accountsReceivableList?.customerAging?.total || 0) | currency: 'USD' }}
                  </span>
                </div>

                <div class="ar-account-right-box">
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-4 pr-0">
            <div class="ar-account-box">
              <div class="ar-account-content">
                <div class="ar-account-left-box">
                  <h6 class="account-header">
                    <span>
                      <span>Limit available</span>
                      <i class="fal fa-info-circle font-12 ml-2" tooltipPosition="top"
                        pTooltip="Remaining credit available to the customer. This indicates how much more credit the customer can utilize before reaching their maximum limit."></i>
                    </span>
                  </h6>
                  <span *ngIf="customer?.chargeAccountDetails?.unlimited">Unlimited</span>

                  <span [hidden]="customer?.chargeAccountDetails?.unlimited" class="ar-account-number"
                    [ngClass]="{'text-danger-color': customer?.chargeAccountDetails?.availableLimit <= 0, 'text-primary': customer?.chargeAccountDetails?.availableLimit > 0}">
                    {{customer?.chargeAccountDetails?.availableLimit | currency: 'USD' }}
                  </span>
                </div>
                <div class="ar-account-right-box">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ar-account-card ar-account-table p-0 mt-3">
          <table class="table">
            <thead>
              <tr>
                <th class="name">Customer Credit History</th>
                <th class="date">0-30</th>
                <th class="date">30-60</th>
                <th class="date">60-90</th>
                <th class="date">90+</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr class="customer-grid-row-body">
                <td class="name">Receivable history</td>
                <td class="date">{{accountsReceivableList?.customerAging?.firstMonth || 0 | currency : 'USD'}}</td>
                <td class="date">{{accountsReceivableList?.customerAging?.secondMonth || 0 | currency : 'USD'}}</td>
                <td class="date">{{accountsReceivableList?.customerAging?.thirdMonth || 0 | currency : 'USD'}}</td>
                <td class="date">{{accountsReceivableList?.customerAging?.MoreThanThreeMonths || 0 | currency : 'USD'}}
                </td>
                <td class="re-amount">{{accountsReceivableList?.customerAging?.total || 0 | currency: 'USD'}}</td>
              </tr>
              <tr class="customer-grid-row-body">
                <td class="name">Payment history</td>
                <td class="date">{{accountsReceivableList?.payments?.firstMonth || 0 | currency : 'USD'}}</td>
                <td class="date">{{accountsReceivableList?.payments?.secondMonth || 0 | currency : 'USD'}}</td>
                <td class="date">{{accountsReceivableList?.payments?.thirdMonth || 0 | currency : 'USD'}}</td>
                <td class="date">{{accountsReceivableList?.payments?.MoreThanThreeMonths || 0 | currency : 'USD'}}</td>
                <td class="re-amount">{{accountsReceivableList?.payments?.total || 0 | currency: 'USD'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- statment -->
        <div class="ui-g-12 p-0 mt-3 ar-account-card flex-between-center">
          <div class="order-report ui-g-12 p-0">
            <div class="order-report-filter expanded-filter statement-filter d-flex">
              <div class="order-report-details">
                <div class="report-icon-wrapper">
                  <i class="far fa-file-invoice"></i>
                </div>
                <div class="report-content-wrapper">
                  <p>Statements</p>
                  <h5>
                    {{totalUnpaidStatement || 0}} Unpaid
                    <span class="date">
                      Due {{unpaidStatementAmt || 0 | currency: 'USD'}}
                    </span>
                  </h5>
                </div>
              </div>

              <div class="left-auto">
                <button class="btn btn-primary btn-submit btn-statement mr-2" (click)="openBulkPaymentModal()">
                  <i class="fal fa-plus"></i>&nbsp;&nbsp;<span>Bulk payment</span>
                </button>
                <button class="btn btn-primary btn-submit btn-statement" (click)="openStatementModal()">
                  <i class="fal fa-plus"></i>&nbsp;&nbsp;<span>Statement</span>
                </button>
              </div>
            </div>


            <div class="order-report-body ui-g-12">
              <p-table class="order-report-list" #dt [columns]="statmentCols" [value]="records" [scrollable]="true"
                [lazy]="true" [responsive]="true" (onLazyLoad)="onLazyLoad($event)" [sortField]="defaultSortField"
                [sortOrder]="defaultSortOrder" [paginator]="totalRecords>0" [rows]="recordsPerPage" [totalRecords]="totalRecords"
                [(first)]="first">

                <!-- Table Header -->
                <ng-template pTemplate="header" let-columns>
                  <tr class="order-report-row-header">
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngClass]="col.headerClass">
                      <span class="position-relative">
                        <span>{{col.title}}</span>
                        <span class="td-custom-sort-header">
                          <p-sortIcon *ngIf="filterState.sortField === col.field" [field]="col.field">
                          </p-sortIcon>
                        </span>
                      </span>
                    </th>
                  </tr>
                </ng-template>

                <!-- Table Body -->
                <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
                  <tr class="rder-report-grid-row">
                    <td *ngFor="let col of columns" [ngClass]="col.dataClass">
                      <span *ngIf="col.field === 'name'" class="pointer hover-underline"
                        (click)="openExsistingStatementModal(rowData?._id)">
                        {{ rowData[col.field] }}
                      </span>

                      <span *ngIf="col.field === 'createdAt' || col.field === 'sendDate'">
                        {{ rowData[col.field] | date: col.pipeArgs }}
                      </span>

                      <span
                        *ngIf="col.field === 'invoiceTotal' || col.field === 'paidToDate' || col.field === 'balanceDue'">
                        {{ rowData[col.field] | currency: col.pipeArgs }}
                      </span>

                      <span *ngIf="!col.pipeArgs && col.field !== 'name'">
                        {{ rowData[col.field] }}
                      </span>
                    </td>
                  </tr>
                </ng-template>

              </p-table>
            </div>

            <div *ngIf="!loading && !records.length" class="ui-g-12 not-found">
              <span class="font-gray-35 font-12 mt-2">There are no records</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-tabPanel>

  <p-tabPanel *ngIf="isCustomerPaymentEnabled" header="All Payments">
    <div class="customer-payments">
      <p class="mb-2 ar-payment-table-title">Unapplied payments</p>

      <div class="ar-payment-table">
        <div class="ar-payment-table-header">
          <div class="ar-payment-table-row">
            <div *ngFor="let header of customerPaymentTable.cols" class="th {{header?.class}}">
              {{header?.name}}
            </div>
          </div>
        </div>

        <div class="ar-payment-table-body">
          <div *ngIf="isCustomerPaymentLoading" class="flex-center-center">
            <i class="fal fa-spinner rotate"></i>
          </div>

          <ng-container *ngIf="!isCustomerPaymentLoading">
            <div *ngFor="let payment of customerUnAppliedPayments" class="ar-payment-table-row">
              <div *ngFor="let header of customerPaymentTable.cols" class="td {{header?.class}}">
                {{payment[header?.field]}}
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <p class="mb-2 mt-5 ar-payment-table-title">Applied payments</p>

      <div class="ar-payment-table">
        <div class="ar-payment-table-header">
          <div class="ar-payment-table-row">
            <div *ngFor="let header of customerPaymentTable.cols" class="th {{header?.class}}">
              {{header?.name}}
            </div>
          </div>
        </div>

        <div class="ar-payment-table-body">
          <div *ngIf="isCustomerPaymentLoading" class="flex-center-center">
            <i class="fal fa-spinner rotate"></i>
          </div>

          <ng-container *ngIf="!isCustomerPaymentLoading">
            <div *ngFor="let payment of customerAppliedPayments" class="ar-payment-table-row">
              <div *ngFor="let header of customerPaymentTable.cols" class="td {{header?.class}}">
                {{payment[header?.field]}}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
